import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import { DatePicker } from './datePicker';

export class FilterModalDatePicker extends PureComponent {
  static propTypes = {
    setFilterDataByFilterName: PropTypes.func.isRequired,
    currentFilter: PropTypes.object.isRequired,
    setTouched: PropTypes.func.isRequired,
  };

  handleDateSelected = data => {
    this.props.setFilterDataByFilterName(this.props.currentFilter.name, data);
    this.props.setTouched();
  };

  render() {
    return <DatePicker activeDate={this.props.currentFilter.data} onDateSelected={this.handleDateSelected} />;
  }
}
